// extracted by mini-css-extract-plugin
module.exports = {"blog":"blog-module--blog--Zytvp","center":"blog-module--center--3WRL_","links":"blog-module--links--3tnjo","link":"blog-module--link--2D1kD","active":"blog-module--active--1jSo1"};